/**
 * @module websocket.event.handlers.airports.airport-updated
 */
import { store } from '../../../../state/store'
import { setAirportItemUpdated } from '../../../../state/websocket.slice'

export default function handleAirportUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirportUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirportItemUpdated(data))
  }
} 